import { useCallback, useEffect } from 'react';
import { useSetImmerAtom } from 'jotai-immer';
import { editStateGroupsCreateAtom, createModelGroupAtom, readOnlycreateModelGroupAtom } from '../groups_create_atoms';
import { createMemberAddDroplist, editStateVM, membersVM, modelVM } from '../groups_create_view_models';
import { getDetail } from '../../data/groupsRepo';
import { useGroupsCreateStore } from '../pagehooks/useGroupsCreateStore';

export const useGroupsCreateFormInit = (): void => {
    const { state: pageState } = useGroupsCreateStore();
    const setState = useSetImmerAtom(editStateGroupsCreateAtom);
    const setModel = useSetImmerAtom(createModelGroupAtom);
    const setReadOnlyModel = useSetImmerAtom(readOnlycreateModelGroupAtom);

    const getModel = useCallback(
        async (id: string): Promise<void> => {
            try {
                const r = await getDetail(id);
                const model = modelVM(r);

                setModel(() => model);
                setReadOnlyModel(() => model);
                setState(draft => {
                    draft.members = membersVM(r);
                    draft.memberAddDropList = createMemberAddDroplist(model.Type.val, draft.members);
                });
            } catch (err: any) {
                console.error(err);
                // handled upstream, need a catch when using a try/finally
            } finally {
                setState(draft => {
                    draft.waiting = false;
                });
            }
        },
        [setModel, setState, setReadOnlyModel],
    );

    useEffect(() => {
        setState(draft => {
            if (pageState.mode == 'CREATE') {
                setModel(() => modelVM({ ObjectState: 'ACTIVE' }));
                draft.waiting = false;
            } else if (!draft.waiting) {
                draft.waiting = true;
                getModel(pageState.id);
            }
            return draft;
        });

        // destroy atoms
        return (): void => {
            setState(() => editStateVM());
            setModel(() => modelVM());
        };
    }, [pageState.mode, setState, setModel, pageState.id, getModel]);
};
